export const latexType = 'latex';
